import { cn } from '@/shared/helpers/classnames'

import type { FC } from 'react'

import type { DialogBodyProps } from './types'

/**
 * Dialog Body component
 */
export const DialogBody: FC<DialogBodyProps> = ({ children, variant = 'default' }) => {
  return (
    <div
      className={cn('dialog-body', {
        'dialog-body-default': variant === 'default',
        'dialog-body-no-padding': variant === 'no-padding',
      })}
    >
      {children}
    </div>
  )
}

DialogBody.displayName = 'DialogBody'
